/**
 * 🧮 CALCULATION EXTRACTOR (Relational Mapping)
 * Location: src/registered/site-admin/components/Workflow-esg/services/calculationExtractor.js
 * Purpose: Transforms the calculation sheet into a high-speed Lookup Map 
 * to enable the "Single Pot" relational join.
 */
export default function extractCalculations(rows, indexMap) {
  const calculationMap = {};

  // 🎯 FUZZY KEY LOOKUP: Matches headers regardless of case or spacing
  const getIdx = (target) => {
    const key = Object.keys(indexMap).find(k => 
      k.toLowerCase().trim() === target.toLowerCase().trim()
    );
    return indexMap[key];
  };

  const T_IDX = getIdx("Technical Name");
  const W_IDX = getIdx("Weight");
  const B_IDX = getIdx("Balance");
  const F_IDX = getIdx("Type name short"); // Captures 'monetary', 'percent', etc.

  // Validation: If the sheet structure is wrong, return empty map to prevent crash
  if (T_IDX === undefined) {
    console.error("❌ [EXTRACTOR:CALC] Critical Column 'Technical Name' not found.");
    return {};
  }

  // Iterate over rows to build the Finance Face
  for (let i = 1; i < rows.length; i++) {
    const r = rows[i];
    const id = r[T_IDX];
    
    if (!id) continue;

    // We index by Technical ID to allow the SchemaBuilder to perform a "Left Join"
    calculationMap[id] = {
      weight: parseFloat(r[W_IDX]) || 1,
      format: r[F_IDX] || "text",
      balance: r[B_IDX] || null
    };
  }

  console.log(`✅ [EXTRACTOR:CALC] Map generated with ${Object.keys(calculationMap).length} math rules.`);
  return calculationMap;
}